import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import OnboardingModal from "./OnboardingModal";
import HelpFAB from "./HelpFAB";
import PushBanner from "./PushBanner";
import SecurityBanner from "./SecurityBanner";
import PrivacyConsentModal from "./PrivacyConsentModal";
import SupplierCodeConsentModal from "./SupplierCodeConsentModal";
import { motion } from "framer-motion";

export default function AppLayout() {
  return (
    <div className="flex bg-slate-50 min-h-screen">
      <Sidebar />
      <motion.main
        key={window.location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.12, ease: "easeOut" }}
        className="flex-1 min-w-0"
      >
        <SecurityBanner />
        <PushBanner />
        <Outlet />
      </motion.main>
      <OnboardingModal />
      <HelpFAB />
      <PrivacyConsentModal />
      <SupplierCodeConsentModal />
    </div>
  );
}
